export const messages = {
  en: {
    registerProtocol: {
      userProtocol: 'User Agreement',
      merchantProtocol: 'Merchant Agreement',
      required: 'Required, please fill in the content',
      modifySuccess: 'Modification successful',
      modifyFailed: 'Modification failed'
    }
  },
  zh: {
    registerProtocol: {
      userProtocol: '用户协议',
      merchantProtocol: '商家协议',
      required: '必填，请填写内容',
      modifySuccess: '修改成功',
      modifyFailed: '修改失败'
    }
  }
}